import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, Subject } from 'rxjs';
import { CcTokentRequestDto } from '../dtos/cc-token-request-dto.model';
import { CcTokenResponseDto } from '../dtos/cc-token-response-dto.model';
import { ConfigService } from './config.service';
import { CommonProxyApiService } from './commonproxyapi.service';
import { CommonProxyApiRequestModel } from '../dtos/commonproxy-api-request-model';

@Injectable({
  providedIn: 'root'
})
export class TokenizeService {
  error = new Subject();
  private readonly _configService: ConfigService;
  private readonly _commonProxyService: CommonProxyApiService;
  private readonly _httpClient: HttpClient;

  constructor(configService: ConfigService, commonProxyService: CommonProxyApiService, httpClient: HttpClient) {
    this._httpClient = httpClient;
    this._configService = configService;
    this._commonProxyService = commonProxyService;
  }

  getCcToken(payload: CcTokentRequestDto): Observable<CcTokenResponseDto> {
    // let serializedPayload = JSON.stringify(payload);
    // let data = new CommonProxyApiRequestModel(serializedPayload);
    // let url = "CreditCardGateway/Tokenize";
    // return this._commonProxyService.callApiAsync<CcTokenResponseDto>(url, data);
    return this._httpClient.post<CcTokenResponseDto>(`${this._configService.ccTokenUrl}`, payload);
  }
}
